import role from '../helpers/role';

import NewRecordset from '../records/NewRecordSet.vue';
import RecordSets from '../records/RecordSets.vue';
import NewRecord from '../records/NewRecord.vue';
import Records from '../records/Records.vue';


const routes = [{
	path: '/recordsets',
	name: 'recordsets',
	component: RecordSets,
	meta: {
		authorize: [{ name: role.RecordAdmin }],
	},
}, {
	path: '/newrecordset',
	name: 'newrecordset',
	component: NewRecordset,
	meta: {
		authorize: [{ name: role.RecordAdmin }],
	},
}, {
	path: '/updaterecordset/:id',
	name: 'updaterecordset',
	component: NewRecordset,
	meta: {
		authorize: [{ name: role.RecordAdmin }],
	},
},
{
	path: '/records/:id',
	name: 'records',
	component: Records,
	meta: {
		authorize: [{ name: role.RecordAdmin }],
	},
}, {
	path: '/newrecord/:setId',
	name: 'newrecord',
	component: NewRecord,
	meta: {
		authorize: [{ name: role.RecordAdmin }],
	},
}, {
	path: '/updaterecord/:id',
	name: 'updaterecord',
	component: NewRecord,
	meta: {
		authorize: [{ name: role.RecordAdmin }],
	},
}];

export default routes;
